import { DatePicker } from "antd";
import dayjs from "dayjs";
import { CompanySelector } from "../../../components/CompanySelector/index.jsx";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/Calendar_Today.svg";
import { tallMenuSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";

const LoginReportPanel = ({
  t,
  reportI18nKeys,
  datePickerLocale,
  selectedReportOption,
  memberCompaniesOptions,
  loadingMemberCompanies,
  setSelectedMemberCompany,
  startDate,
  endDate,
  isStartCalendarOpen,
  setIsStartCalendarOpen,
  isEndCalendarOpen,
  setIsEndCalendarOpen,
  handlers,
}) => {
  const {
    onStartDateChange,
    onEndDateChange,
    getDisabledStartDate,
    getDisabledEndDate,
  } = handlers;

  return (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.COMPANY)}</label>
      <CompanySelector
        companies={memberCompaniesOptions}
        loading={loadingMemberCompanies}
        isDisabled={!selectedReportOption}
        placeholder={t(reportI18nKeys.COMPANY_PLACEHOLDER)}
        styles={tallMenuSelectStyles}
        onChange={setSelectedMemberCompany}
      />
    </div>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t("pages.reports.startDate")}</label>
      <DatePicker
        name="startDate"
        open={isStartCalendarOpen}
        value={startDate ? dayjs(startDate) : null}
        onChange={onStartDateChange}
        onOpenChange={setIsStartCalendarOpen}
        format="DD/MM/YYYY"
        inputReadOnly
        suffixIcon={<CalendarIcon className={styles.calendarIcon} />}
        locale={datePickerLocale}
        disabledDate={getDisabledStartDate}
      />
    </div>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t("pages.reports.endDate")}</label>
      <DatePicker
        name="endDate"
        open={isEndCalendarOpen}
        value={endDate ? dayjs(endDate) : null}
        onChange={onEndDateChange}
        onOpenChange={setIsEndCalendarOpen}
        format="DD/MM/YYYY"
        inputReadOnly
        suffixIcon={<CalendarIcon className={styles.calendarIcon} />}
        locale={datePickerLocale}
        disabledDate={getDisabledEndDate}
      />
    </div>
  </ReportFilterSection>
  );
};

export default LoginReportPanel;
